import React, { useEffect, useState } from 'react';
import { TileContainer } from "@vds3/tiles";
import { Title,Body,Micro } from '@vds3/typography'
import { MarginSpacerL, MarginSpacerM, MarginSpacerS } from '../../Checkout/styleTag';
import { useSelector } from 'react-redux';
import { TextLink } from '@vds3/buttons';
import { Modal, ModalTitle, ModalBody } from '@vds3/modals';
import { Button } from '@vds3/buttons';

const PlanDetails = (props) => {
    const [routerDetails,setRouterDetails] = React.useState(undefined);
    const [phoneDetails,setPhoneDetails] = React.useState(undefined);
    const servicesInCart = useSelector((state) => state.CustomizeOrder?.servicesInCart)
    const {SetDueDate, installments, savedPaymentMethodType} = useSelector((state)=>state.CheckoutPage);
    const {dueDate, timeSlot} = SetDueDate || {};
    const {autoPay, paperFreeBilling} = installments || {};
    useEffect(()=>{
        if((props?.getFloatCartResponse?.planDetails?.otherServices && props?.getFloatCartResponse?.planDetails?.otherServices.length) || (props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges && props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.length)){
            let getRentRouter = props?.getFloatCartResponse?.planDetails?.otherServices.find((item)=>String(item?.Product).toLowerCase().includes('router'));
             if(props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges && props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.length){
                getRentRouter = props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.find((item)=>String(item?.type).toUpperCase().includes('NONBDV')&&String(item?.offerName).toUpperCase().includes('ROUTER'));
                getRentRouter = {...getRentRouter,Product:getRentRouter?.offerName}
            }
            setRouterDetails({...getRentRouter,planName:String(props?.getFloatCartResponse?.planDetails?.dataInfo?.planName).split('-')[0]});
        }else{
            if(props?.getFloatCartResponse?.planDetails?.dataInfo?.planName){
                setRouterDetails({Product:"Your own router: Use",planName:String(props?.getFloatCartResponse?.planDetails?.dataInfo?.planName).split('-')[0]});
            }
        }
        if(props?.getFloatCartResponse?.planDetails?.phoneInfo && props?.getFloatCartResponse?.planDetails?.phoneInfo?.noOfLines){
            let equipment = []
            if(props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges && props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.length){
                equipment = props?.getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges.filter((item)=>String(item?.type).toUpperCase().includes('BDV'));
            }
            setPhoneDetails({...props?.getFloatCartResponse?.planDetails?.phoneInfo,equipment})
        }
    },[])
    const autoPaperValue = (autoPay && paperFreeBilling) ? 'Y' : (!(autoPay || paperFreeBilling)) ? 'N' : (autoPay && !paperFreeBilling? 'NY':'YN')
    return (
        <div>
            {servicesInCart!=="BDV"?<><PlanTab routerDetails={routerDetails} dueDate={dueDate} timeSlot={timeSlot} autoPaperValue={autoPaperValue} savedPaymentMethodType={savedPaymentMethodType} installments={installments} servicesInCart={servicesInCart} {...props}/>
            <MarginSpacerM/></>:<></>}
            {servicesInCart!=="DATA"?<PhoneTab phoneDetails={phoneDetails} dueDate={dueDate} timeSlot={timeSlot} autoPaperValue={autoPaperValue} savedPaymentMethodType={savedPaymentMethodType} installments={installments} servicesInCart={servicesInCart} {...props}/>:<></>}
        </div>
    );
};


const PlanTab = ({routerDetails,dueDate,timeSlot,autoPaperValue,savedPaymentMethodType,installments,servicesInCart,...props})=>{
    const [openModal,setOpenModal] = useState(false)
    const  closeModal = (modal) => {
        setOpenModal(modal)
    }
    let date = new Date(dueDate);
    let month = date.toLocaleString('default', { month: 'long' });
        let dates=date.getDate();
    if(routerDetails){
        const splitDetails = routerDetails?.Product?.split(':');
        return(
        <div>
            {openModal?<RouterDetailModal openModal={openModal} closeModal={(val)=>closeModal(val)} dueDate={dueDate} timeSlot={timeSlot} autoPaperValue={autoPaperValue} savedPaymentMethodType={savedPaymentMethodType} installments={installments} servicesInCart={servicesInCart} {...props}/>:<></>}
            <TileContainer
                padding='24px'
                aspectRatio='1:1'
                height="175px"
                id="tile-cont-confim"
                >
               <div className='tile-con-tab-confirm'>
                <div style={{width:'124px'}}>
                    <img src="images/CrownRouter.png" width={'100px'} height={'124px'} />
                </div>
                <div>
                    <Micro color="#6F7171">Router</Micro>
                    <Title size="medium" bold>{splitDetails?.[1] || ""} {splitDetails?.[0] || ""}</Title>
                    <MarginSpacerS/>
                    <Body size="large">Installation date</Body>
                    <Body size="large">{`${month} ${dates}, ${timeSlot.split("and")?.[0]} - ${timeSlot.split('and')?.[1]} `}{<TextLink onClick={()=>setOpenModal(true)} type="standAlone" surface="light" disabled={false}>Details</TextLink>}</Body>
                    <MarginSpacerM/>
                    <Micro color="#6F7171">Internet plan</Micro>
                    <Title size="medium">{routerDetails?.planName}</Title>
                </div>
               </div>
            </TileContainer>
        </div>
    )
    }else return <></>
}

const PhoneTab = ({phoneDetails,dueDate,timeSlot,servicesInCart,autoPaperValue,savedPaymentMethodType,installments,...props})=>{
    const [openModal,setOpenModal] = useState(false)
    const  closeModal = (modal) => {
        setOpenModal(modal)
    }
    let date = new Date(dueDate);
    let month = date.toLocaleString('default', { month: 'long' });
        let dates=date.getDate();
    const equipmentName = []
    if(phoneDetails&&phoneDetails?.equipment&&phoneDetails?.equipment.length){
        phoneDetails.equipment.map(data=>{
            if(String(data['offerName']).split('(')[0]!="Business Digital Voice Shipping ")
            equipmentName.push(String(data['offerName']).split('(')[0])
        })
    }
    if(phoneDetails){
        return(
        <div>
            {openModal?<RouterDetailModal openModal={openModal} closeModal={(val)=>closeModal(val)} dueDate={dueDate} timeSlot={timeSlot} autoPaperValue={autoPaperValue} savedPaymentMethodType={savedPaymentMethodType} installments={installments} servicesInCart={servicesInCart} {...props}/>:<></>}
            <TileContainer
                padding='24px'
                aspectRatio='1:1'
                height="175px"
                id="tile-cont-confim"
                >
               <div className='tile-con-tab-confirm'>
                <div style={{width:'124px'}}>
                    <img src="images/img_w56P.png" width={'124px'} height={'124px'} />
                </div>
                <div>
                    <Micro color="#6F7171">Desktop phone</Micro>
                    <Title size="medium" bold>{equipmentName.join()}</Title>
                    {servicesInCart==="BDV"?
                    <><MarginSpacerS/>
                    <Body size="large">Installation date</Body>
                    <Body size="large">{`${month} ${dates}`}{timeSlot?`, ${timeSlot.split("and")?.[0]} - ${timeSlot.split('and')?.[1]} `:""}{<TextLink onClick={()=>setOpenModal(true)} type="standAlone" surface="light" disabled={false}>Details</TextLink>}</Body></>:""}
                    <MarginSpacerM/>
                    <Micro color="#6F7171">Phone lines</Micro>
                    <Title size="medium">{phoneDetails?.noOfLines} lines</Title>
                </div>
                
               </div>
            </TileContainer>
        </div>
    )
    }else return <></>
}

const RouterDetailModal =({openModal,closeModal,dueDate,timeSlot,autoPaperValue,savedPaymentMethodType,installments,servicesInCart,...props})=>{
    let cardHolderName = installments?.fullName?installments?.fullName.replace(/\s+/g, ""):"";
    let nameToDisplay=["Y","NY"].some((p)=>autoPaperValue=== p) && ["creditcards","debitcards"].some((c)=>c===savedPaymentMethodType)?cardHolderName.toLowerCase()===(props?.contactInfo?.firstName.trim()+props?.contactInfo?.lastName.trim()).toLowerCase()?"":installments?.fullName?installments?.fullName:"":""

    return (
        <Modal
            ariaLabel=""
            opened={openModal}
            onOpenedChange={closeModal}
            disableOutsideClick={true} disableFocusLock= {true} 
        >

            <ModalTitle>
            {servicesInCart==="BDV"?
                <Title size="large" bold>Prepare for your installation</Title>: <Title size="large" bold>Your Fios installation appointment</Title>}

            </ModalTitle>
            <ModalBody>

            <Body size="large">
                    Your technician will arrive at the time and date you selected{dueDate && timeSlot?":":"."}
                </Body>
                <Body size="large">
                    {dueDate && timeSlot ?(dueDate +" between "+ timeSlot.split("and")?.[0]+" - "+timeSlot.split("and")?.[1]):""}
                </Body>
                <MarginSpacerL/>
                {["SoleOwner","Partner"].some((c)=>c===props?.customerType) || nameToDisplay?
                <>
                <Body size="large">
                    Point-of-contact person:
                </Body>
                <Body size="large">
                    {["SoleOwner","Partner"].some((c)=>c===props?.customerType)?`${props?.contactInfo?.firstName} ${props?.contactInfo?.lastName}`:nameToDisplay?nameToDisplay:""} 
                </Body>
                <MarginSpacerL/>
                </>:<></>}
                <Body size="small">
                    Ensure you have permission for this installation with your landlord.
                    Ensure there will be electricity connected in your business address on the day of the installation.
                    An adult 18 years old or older must be present during the installation.Provide access to the Telco room in your building, if applicable.
                </Body>
                <MarginSpacerL/>
                <Button use="primary" onClick={()=>closeModal(false)} style={{width:"50%"}}>Close</Button>
                </ModalBody>
        </Modal>
    )
}

export default PlanDetails;